if (!customElements.get('smoke-occasions')) {
  customElements.define(
    'smoke-occasions',
    class SmokeOccasions extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.occasions = Array.from(this.querySelectorAll('[data-smoke-occasion]'));
        this.desktopMedia = window.matchMedia('(min-width: 990px)');
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        const handleBlockSelect = (event) => {
          const blockId = event.detail?.blockId;
          if (!blockId) return;

          const index = this.occasions.findIndex(
            (occasion) => occasion.dataset.blockId === blockId
          );
          if (index >= 0) this.activate(index);
        };

        this.occasions.forEach((occasion, index) => {
          const card = occasion.querySelector('[data-smoke-card]');
          card?.addEventListener('mouseenter', () => this.activate(index), { signal });
          card?.addEventListener('focus', () => this.activate(index), { signal });
          card?.addEventListener('click', () => this.activate(index), { signal });
        });

        this.desktopMedia.addEventListener('change', () => this.updateInteractionMode(), { signal });
        this.addEventListener('shopify:block:select', handleBlockSelect, { signal });
        document.addEventListener('shopify:block:select', handleBlockSelect, { signal });

        this.activateInitialImage();
        this.updateInteractionMode();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.initialized = false;
      }

      updateInteractionMode() {
        const desktop = this.desktopMedia.matches;
        this.occasions.forEach((occasion) => {
          const card = occasion.querySelector('[data-smoke-card]');
          const media = occasion.querySelector('[data-smoke-media]');
          const active = occasion.classList.contains('is-active');

          if (card) {
            card.tabIndex = desktop ? 0 : -1;
            card.toggleAttribute('aria-disabled', !desktop);
            if (desktop) {
              card.setAttribute('aria-pressed', active ? 'true' : 'false');
            } else {
              card.removeAttribute('aria-pressed');
              if (card === document.activeElement) card.blur();
            }
          }

          media?.setAttribute('aria-hidden', desktop && !active ? 'true' : 'false');
        });
      }

      activateInitialImage() {
        if (!this.desktopMedia.matches) return;

        const active = this.occasions.find((occasion) => occasion.classList.contains('is-active'));
        if (active?.dataset.smokeHasImage === 'true') return;

        const firstWithImage = this.occasions.findIndex(
          (occasion) => occasion.dataset.smokeHasImage === 'true'
        );
        if (firstWithImage >= 0) this.activate(firstWithImage);
      }

      activate(index) {
        if (!this.desktopMedia.matches) return;

        this.occasions.forEach((occasion, occasionIndex) => {
          const active = occasionIndex === index;
          occasion.classList.toggle('is-active', active);
          occasion.querySelector('[data-smoke-card]')?.setAttribute('aria-pressed', active ? 'true' : 'false');
          occasion.querySelector('[data-smoke-media]')?.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      }
    }
  );
}
